import React from 'react';
import { ButtonV2, Container, CustomImage } from 'components/shared';
import { CaptionWithMB, H2 } from './styleConstants';
import { CaretUp } from 'assets/icons';
import styles from './EcosystemProductsSection.module.css';

type Step = {
  title: string;
  subtitle: string;
  img: string;
  badgeColor?: string;
  ctaTitle: string;
  ctaHref: string;
};

export const EcosystemProductsSection = React.forwardRef<HTMLElement>(
  (props, ref) => {
    const steps: Step[] = [
      {
        title: 'Ring AIR',
        subtitle: `Continuously tracks sleep, HRV, temperature, and movement, turning these signals into clear, daily actionable health insights.`,
        img: 'web_v2/partners/products/v2/air.png',
        badgeColor: '#FFFFFF',
        ctaTitle: 'Learn more',
        ctaHref: '/ring',
      },
      {
        title: 'Blood Vision',
        subtitle:
          'Comprehensive bloodwork across metabolic, cardiovascular, immune, hormonal, and nutritional health, with an AI clinical summary and personalised guidance.',
        img: 'web_v2/partners/products/v2/bv.png',
        badgeColor: '#F6F6F6',
        ctaTitle: 'Learn more',
        ctaHref: '/blood-vision',
      },
      {
        title: 'M1 CGM',
        subtitle:
          'Track real-time glucose responses to meals, activity, and lifestyle factors, and use this data to personalise nutrition and exercise decisions.',
        img: 'web_v2/partners/products/v2/m1.png',
        badgeColor: '#FFFFFF',
        ctaTitle: 'Learn more',
        ctaHref: '/pricing',
      },
      {
        title: 'Home Monitor',
        subtitle:
          'A connected health device that monitors your environment, measuring air, temperature, humidity, light, and noise, linking them to your biomarkers.',
        img: 'web_v2/partners/products/v2/home-2.png',
        badgeColor: '#FFFFFF',
        ctaTitle: 'Learn more',
        ctaHref: '/home',
      },
    ];

    return (
      <section
        ref={ref}
        role="region"
        aria-labelledby="getstarted-heading"
        className={styles.section}
      >
        <Container>
          <CaptionWithMB>Solution</CaptionWithMB>
          <H2 id="getstarted-heading" className={styles.title}>
            The Ultrahuman Ecosystem
          </H2>
          <div className={styles.grid}>
            {steps.map((step) => (
              <div className={styles.card} key={step.title}>
                <div className={styles.imageWrap}>
                  <div className={styles.insetBorder} />
                  <CustomImage
                    className={styles.image}
                    src={step.img}
                    alt={step.title}
                    fill
                    sizes="(min-width: 1400px) 318px, (min-width: 992px) 25vw, (min-width: 768px) 720px, 90vw"
                  />
                </div>
                <div className={styles.cardContent}>
                  <h3 className={styles.cardTitle}>{step.title}</h3>
                  <p
                    className={styles.cardSubtitle}
                    dangerouslySetInnerHTML={{ __html: step.subtitle }}
                  />
                  <ButtonV2
                    variant={'flat'}
                    href={step.ctaHref}
                    style={{ padding: '0' }}
                  >
                    {step.ctaTitle}
                    <CaretUp
                      style={{
                        transform: 'rotate(90deg) translateY(-1px)',
                        height: '8px',
                        marginLeft: '4px',
                      }}
                      fill={'#000'}
                    />
                  </ButtonV2>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    );
  },
);

EcosystemProductsSection.displayName = 'EcosystemProductsSection';
